module.exports = __webpack_public_path__ + "static/GherkinLP-600x600-101f1bfb50ed4cb3a4d59a64dd248188.jpg";